export default __webpack_public_path__ + "static/media/liha.65efc4c5.png";